/* tslint:disable:indent */
import {Bounds} from './Core';
import {AxesConfiguration} from './Axis';
import {SeriesConfiguration} from './Series';
import {Marker} from './Marker';
import {GridConfiguration} from './Grid';
import * as $ from 'jquery';
import PlainObject = JQuery.PlainObject;

export interface IComponentLayout {
	plot: Bounds;
}

export interface IRenderContext<T extends IComponentLayout> {
	getComponentLayout(): T;
}

export class RenderContext implements IRenderContext<IComponentLayout> {

	private static DEFAULT_LAYER_NAME = 'default';
	private static LAYER_CLASS = 'layer';
	private static LAYER_NAME_ATTR = 'data-layer';
	public container: JQuery;
	public axesConfiguration = new AxesConfiguration([]);
	public seriesConfiguration = new SeriesConfiguration([]);
	public gridConfiguration = new GridConfiguration();
	public markers: Marker[] = [];
	protected componentLayout: IComponentLayout;

	public constructor(element: string | Element | JQuery | PlainObject<any>) {
		this.container = $('#' + String(element));
		if (this.container.length === 0) {
			throw new Error('No element found for \'' + element + '\'');
		}
		this.componentLayout = this.createComponentLayout();
		this.layoutComponents();
	}

	public getComponentLayout(): IComponentLayout {
		return this.componentLayout;
	}

	protected createComponentLayout(): IComponentLayout {
		return {
			plot: new Bounds()
		};
	}

	public createLayer(name?: string) {
		let canvas = $(document.createElement('canvas'));
		canvas.addClass(RenderContext.LAYER_CLASS);
		canvas.attr(RenderContext.LAYER_NAME_ATTR, name);
		canvas.attr('width', this.getWidth());
		canvas.attr('height', this.getHeight());
		this.container.append(canvas);
		return canvas;
	}

	public getLayer(name = RenderContext.DEFAULT_LAYER_NAME) {
		let selector = 'canvas.' + RenderContext.LAYER_CLASS +
			'[' + RenderContext.LAYER_NAME_ATTR + '=' + name + ']';
		let layers = this.container.find(selector);
		let canvas = (layers.length > 0) ? layers : this.createLayer(name);
		return canvas;
	}

	public getAllLayers(): JQuery {
		return this.container.find('canvas.' + RenderContext.LAYER_CLASS);
	}

	public getContext(layerName = RenderContext.DEFAULT_LAYER_NAME, zIndex= 0) {
		let layers = this.getLayer(layerName);
		let layer = layers[0];
		if (layer instanceof HTMLCanvasElement) {
			layer.style.zIndex = '' + zIndex;
			return layer.getContext('2d');
		}
	}

	public getWidth(): number {
		return this.container.innerWidth();
	}

	public getHeight(): number {
		return this.container.innerHeight();
	}

	protected resize(canvas: JQuery) {
		let prevWidth = canvas.attr('width');
		let prevHeight = canvas.attr('height');
		let width = this.getWidth();
		let height = this.getHeight();
		if (prevWidth == width.toString() && prevHeight == height.toString()) {
			return;
		}
		canvas.attr('width', width);
		canvas.attr('height', height);
		this.layoutComponents();
	}

	public onResize() {
		this.resize(this.getAllLayers());
	}

	protected layoutComponents() {
		this.componentLayout.plot.width = this.getWidth();
		this.componentLayout.plot.height = this.getHeight();

	}
}
